import HomePage from "./components/HomePage";
import AboutUsPage from "./components/pages/AboutUsPage";
import WelcomeMessagePage from "./components/pages/WelcomeMessagePage";
import ConstitutionPage from "./components/pages/ConstitutionPage";
import ContactUsPage from "./components/pages/ContactUsPage";
import JoinUsPage from "./components/pages/JoinUsPage";
import WhatIsMediationPage from "./components/pages/WhatIsMediationPage";
import WhyMediationPage from "./components/pages/WhyMediationPage";
import MediationProcessPage from "./components/pages/MediationProcessPage";
import MPMHKPage from "./components/pages/MPMHKPage";
import WhoNeedsServicePage from "./components/pages/WhoNeedsServicePage";
import MediationFeesPage from "./components/pages/MediationFeesPage";
import HKASMediationRulesPage from "./components/pages/HKASMediationRulesPage";
import MediationQAPage from "./components/pages/MediationQAPage";
import WhatIsArbitrationPage from "./components/pages/WhatIsArbitrationPage";
import EfficientArbitrationPage from "./components/pages/EfficientArbitrationPage";
import WhyHKASRulesPage from "./components/pages/WhyHKASRulesPage";
import ArbitrationClausesPage from "./components/pages/ArbitrationClausesPage";
import ArbitrationAgreementPage from "./components/pages/ArbitrationAgreementPage";
import ArbitrationSocietyRulesPage from "./components/pages/ArbitrationSocietyRulesPage";
import ArbitrationProcessPage from "./components/pages/ArbitrationProcessPage";
import HearingTimetablePage from "./components/pages/HearingTimetablePage";
import ArbitrationFeesPage from "./components/pages/ArbitrationFeesPage";
import Enforcement from "./components/pages/Enforcement";
import ArbitrationQAPage from "./components/pages/ArbitrationQAPage";
import HKRenovationGuidelinePage from "./components/pages/HKRenovationGuidelinePage";
import AboutCharterPage from "./components/pages/AboutCharterPage";
import RecognitionCeremonyReviewPage from "./components/pages/RecognitionCeremonyReviewPage";
import ListofParticipatingInstitutionsPage from "./components/pages/ListofParticipatingInstitutionsPage";
import RecognitionPage2019 from "./components/pages/RecognitionPage2019";
import SignTheCharterPage from "./components/pages/SignTheCharterPage";
import RadioProgramPage from "./components/pages/RadioProgramPage";
import SocietyNewsPage from "./components/pages/SocietyNewsPage";
import SocietyNewsPageDetail from "./components/pages/SocietyNewsPageDetail";
import DecorationPage from "./components/pages/DecorationPage";
import ShareLawPage from "./components/pages/ShareLawPage";
import DecoAcademyPage from "./components/pages/DecoAcademyPage";
import Renovation1plusHk from "./components/pages/Renovation1plus_hk";
import { Routes, Route } from "react-router-dom";
import Events from "./components/pages/Events";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/decoacademy" element={<DecoAcademyPage />} />
        <Route path="/renovation1plushk" element={<Renovation1plusHk />} />
        <Route path="/events" element={<Events />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/welcomemessage" element={<WelcomeMessagePage />} />
        <Route path="/constitution" element={<ConstitutionPage />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        <Route path="/joinus" element={<JoinUsPage />} />
        <Route path="/whatismediation" element={<WhatIsMediationPage />} />
        <Route path="/whymediation" element={<WhyMediationPage />} />
        <Route path="/mediationprocess" element={<MediationProcessPage />} />
        <Route path="/mpmhk" element={<MPMHKPage />} />
        <Route path="/enforcement" element={<Enforcement />} />
        <Route path="/mediationfees" element={<MediationFeesPage />} />
        <Route
          path="/whoneedsmediationservice"
          element={<WhoNeedsServicePage />}
        />
        <Route
          path="/hkasmediationrules"
          element={<HKASMediationRulesPage />}
        />
        <Route path="/q&a" element={<MediationQAPage />} />
        <Route path="/whatisarbitration" element={<WhatIsArbitrationPage />} />
        <Route
          path="/efficientarbitration"
          element={<EfficientArbitrationPage />}
        />
        <Route path="/whyhkasrules" element={<WhyHKASRulesPage />} />
        <Route
          path="/arbitrationclauses"
          element={<ArbitrationClausesPage />}
        />
        <Route
          path="/arbitrationagreement"
          element={<ArbitrationAgreementPage />}
        />
        <Route
          path="/arbitrationsocietyrules"
          element={<ArbitrationSocietyRulesPage />}
        />
        <Route
          path="/arbitrationprocess"
          element={<ArbitrationProcessPage />}
        />
        <Route path="/hearingtimetable" element={<HearingTimetablePage />} />
        <Route path="/arbitrationfees" element={<ArbitrationFeesPage />} />
        <Route path="/arbitrationq&a" element={<ArbitrationQAPage />} />
        <Route
          path="/hkrenovationguideline"
          element={<HKRenovationGuidelinePage />}
        />
        <Route path="/aboutcharter" element={<AboutCharterPage />} />
        <Route
          path="/recognitionceremonyreview"
          element={<RecognitionCeremonyReviewPage />}
        />
        <Route
          path="/listofparticipatinginstitutions"
          element={<ListofParticipatingInstitutionsPage />}
        />
        <Route
          path="/recognitionceremonyreview2019"
          element={<RecognitionPage2019 />}
        />
        <Route path="/signthecharter" element={<SignTheCharterPage />} />
        <Route path="/radioprogram" element={<RadioProgramPage />} />
        <Route path="/societynews" element={<SocietyNewsPage />} />
        <Route
          path="/societynewsdetail/:id"
          element={<SocietyNewsPageDetail />}
        />
        <Route path="/decoration" element={<DecorationPage />} />
        <Route path="/sharelaw" element={<ShareLawPage />} />
      </Routes>
    </>
  );
};

export default App;
